import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../redux/library/selector";
import { selectBankConfigurationsListItems } from "../../../../../../redux/bank-configurations/selector";
import { bankConfigurations } from "../../../../../../redux/bank-configurations/action";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementBankConfigurations = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const bankConfigurationsItemsData = useSelector(selectBankConfigurationsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'LedgerName', headerName: 'Ledger Name', searchField: 'LedgerName', sortable: true, filter: true, filterType: 'text' },
      { field: 'ChequeBookName', headerName: 'Cheque Book Name', searchField: 'ChequeBookName', sortable: true, filter: true, filterType: 'text' },
      { field: 'StartingNumber', headerName: 'Starting Number' },
      { field: 'EndNumber', headerName: 'End Number' },
      { field: 'NoOfLeaves', headerName: 'No Of Leaves' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
    ]);
  }

  const fetchBankConfigurationsList = () => {
    dispatch(bankConfigurations.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations/list`,
      entity: 'bankConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(bankConfigurations.delete({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations/delete`,
      entity: 'bankConfigurations',
      jsonData:
      {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchBankConfigurationsList();
    });
  }

  const handleReloadData = () => {
    fetchBankConfigurationsList();
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Bank Configuration</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "LedgerName",
        FieldText: "LedgerName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(bankConfigurations.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/bank-configurations/list`,
      entity: 'bankConfigurations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchBankConfigurationsList()
  }, [pageData, pageSize])

  return (
    <>
      {bankConfigurationsItemsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={bankConfigurationsItemsData?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={bankConfigurationsItemsData?.result?.pagination}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true} onSearch={handleSearch}
          additionButtons={additionButtons} onEdit={handleEdit} onDelete={handleDelete}
          headingName="Bank Configurations"
        />
      }
    </>
  );
};

export default ManagementBankConfigurations;



